import { Platform } from '@angular/cdk/platform';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from '@klickdata/core/auth';
import { RecorderTypes } from '@klickdata/core/media/src/media-type';
import { RecorderService, RecordResultsMetaData } from '@klickdata/core/media/src/recorder.service';
import { MobileService } from '@klickdata/core/mobile';
import { User } from '@klickdata/core/user';
import { takeUntil } from 'rxjs/operators';
import { RecorderBase } from '../recorder-base';

@Component({
    selector: 'app-recorder-screen',
    templateUrl: './recorder-screen.component.html',
    styleUrls: ['./recorder-screen.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecorderScreenComponent extends RecorderBase {
    public recorderConfig: any;
    public recordResultsMetaData: RecordResultsMetaData;
    @Input() user: User;

    constructor(
        protected snackBar: MatSnackBar,
        public recordingService: RecorderService,
        protected cdr: ChangeDetectorRef,
        protected auth: AuthService,
        protected mobile: MobileService,
        protected platform: Platform
    ) {
        super(snackBar, recordingService, auth, mobile, platform);
        this.recorderConfig = {
            type: 'video',
            mimeType: 'video/webm',
            canvas: {
                width: 1280,
                height: 720,
            },
        };
        this.recordResultsMetaData = {
            title: $localize`KLMS_recorded_screen`,
            extension: 'webm',
            type: 'video/webm',
        };
    }

    public startRecorder(canRecordUnlimited: boolean) {
        if (this.recordingService.recorder) {
            return;
        }
        if (this.isMobile) {
            this.mobile.toggleMenu();
        }
        const microphone = 'microphone' as PermissionName;
        this.haveRequestedPermissions([{ name: microphone }])
            .pipe(takeUntil(this.destroy))
            .subscribe((havePermissions: boolean) => {
                if (!havePermissions) {
                    return;
                } else {
                    this.recordingService.activeRecordingType = RecorderTypes.SCREEN;
                    return new Promise((resolve, reject) => {
                        var browser = <any>navigator;
                        browser.mediaDevices
                            .getDisplayMedia({
                                video: {
                                    displaySurface: 'monitor',
                                    logicalSurface: true,
                                    cursor: 'always',
                                },
                            })
                            .then((screenStream: MediaStream) => {
                                navigator.mediaDevices
                                    .getUserMedia({ audio: true })
                                    .then((mic: MediaStream) => {
                                        screenStream.addTrack(mic.getTracks()[0]);
                                        this.recordingService.record(
                                            screenStream,
                                            this.recorderConfig,
                                            this.recordResultsMetaData,
                                            !canRecordUnlimited
                                        );
                                        this.showSnackBar();
                                        this.cdr.markForCheck();
                                        resolve(this.stream);
                                    })
                                    .catch((error: any) => {
                                        this.initPermissionWarningSlider({
                                            body: $localize`Pls give KlickData needed microphone permissions from your browser/system security settings to record and then reload the page`,
                                        });
                                    });
                            })
                            .catch((error: any) => {
                                this.initPermissionWarningSlider({
                                    body: $localize`Pls give KlickData needed permissions from your systm security settings to use screen recording`,
                                });
                            });
                    });
                }
            });
    }
}
